import { react, useState } from 'react'
import cv from './files/CV.pdf'
import glitter_paper from './files/glitter_paper.pdf'
import './HomePage.css'
import prophoto from './files/pro1.jpeg'
import prophoto_LA from './files/pro-LA.jpeg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faTwitter, faGoogleScholar } from '@fortawesome/free-brands-svg-icons'
import { faFile, faEnvelope, faHouse } from '@fortawesome/free-solid-svg-icons'
import { Protea_workshop, Oversight, VISAR_Deploy, GLITTER, CodeStream, Editrail, Spot, Searching_ChatGPT, NDU, MusicApp, MondrianCats, VizCode_demo, SPARK, Dataset_webProgramming } from './Projects.js'
import VizCode from './files/VizCode__A_Practical_Real_time_Tool_for_In_Class_Computer_Programming_Tutoring.pdf'
const Publications = () => {
  return (
    <div>
      <Oversight />
      <VISAR_Deploy />
      <Editrail />
      <CodeStream />
      <GLITTER />
      <SPARK />
    </div>
  )
}
const Research_Projects = () => {
  return (
    <div>
      <NDU />
      <Spot />
      {/* <Puzzlemi_JupyterLab /> */}
    </div>
  )
}
const Other_Projects = () => {
  return (
    <div id='other_projects'
    >
      <Dataset_webProgramming />
      <MondrianCats />
      <Searching_ChatGPT />
      <MusicApp />
      <br />
    </div >
  )
}
const toggleText = () => {
  const more_about_me_content = document.getElementById('more_about_me_content')
  const more_about_me_button = document.getElementById('more_about_me')
  if (more_about_me_content.style.display === 'none') {
    more_about_me_content.style.display = ''
    more_about_me_button.innerHTML = 'More about me:'
  } else {
    more_about_me_button.innerHTML = 'More about me'
    more_about_me_content.style.display = 'none'
  }
}
function HoverImage () {
  const [imgSrc, setImgSrc] = useState(prophoto)
  const handleMouseEnter = () => {
    setImgSrc(prophoto_LA)
  }
  const handleMouseLeave = () => {
    setImgSrc(prophoto)
  }

  return (
    <img
      id='photo'
      src={imgSrc}
      alt="photo"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  )
}
const Posters = () => {
  return (
    <div style={{
      border: '1px solid #e5e5e5',
      borderWidth: '0px 0 1px 0px',
    }}>
      {/* <Protea_workshop /> */}
      <VizCode_demo />
    </div>
  )
}
const HomePage = ({ onPortfolioHide }) => {
  const [showPortfolioPage, setShowPortfolioPage] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const handleHidePortfolio = () => {
    setShowPortfolioPage(false)
  }
  const handleShowPortfolio = () => {
    setShowPortfolioPage(true)
  }
  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }
  return (
    <div className='Pagecontainer'>
      <div className='Portfolio_header'>
        <div className='name_container'>
          <span id='name_page'>
            YINUO YANG
          </span>
          {/* <p id='c_name'>杨依诺</p> */}
        </div>
        <a className="menu-button" onClick={toggleMenu}>
          ☰
        </a>
        <div className="custom-social-links">
          <nav id="swup" className="site-head-left">
            <ul className="nav" role="menu">
              <li className="nav-home   " role="menuitem">
                <a href="#" onClick={handleHidePortfolio}>Home</a>
              </li>
              <li className="nav-home   " role="menuitem">
                <a href="#" onClick={handleShowPortfolio}>Portfolio</a>
              </li>
              <li className="nav-home   " role="menuitem">
                <a href='https://dune-ricotta-fe5.notion.site/Yinuo-s-Blog-1d72df463d1180f0b587f99c51ead54d?pvs=4' target="_blank" >Blog</a>
              </li>
              {/* <li className="nav-home   " role="menuitem">
                <a href={cv} target='_blank'>CV</a>
              </li> */}
            </ul>
          </nav>
        </div>
      </div>
      {menuOpen && (
        <div className="custom-social-links-small"
          style={{
            alignItems: 'flex-end'
          }}>
          <nav id="swup" className="site-head-left">
            <ul className="nav" role="menu">
              <li className="nav-home   " role="menuitem">
                <a href="#" onClick={handleHidePortfolio}>Home</a>
              </li>
              <li className="nav-home   " role="menuitem">
                <a href="#" onClick={handleShowPortfolio}>Portfolio</a>
              </li>
              {/* <li className="nav-home   " role="menuitem">
                <a href={cv} target='_blank'>CV</a>
              </li> */}
              <li className="nav-home   " role="menuitem">
                <a href='https://dune-ricotta-fe5.notion.site/Yinuo-s-Blog-1d72df463d1180f0b587f99c51ead54d?pvs=4' target="_blank" >Blog</a>
              </li>
            </ul>
          </nav>
        </div>
      )
      }
      {
        !showPortfolioPage && <div className='MainContent'>
          <div className='about_content'>
            {/* <img id='photo' alt='photo' /> */}
            {/* <HoverImage /> */}
            <p id='bio_page'>
              <p id='self-intro'>
                Hi! I’m Yinuo, a PhD student at the <a href="https://www.nd.edu/" target="_blank">University of Notre Dame</a>, advised by <a href="https://toby.li/" target="_blank">Prof. Toby Jia-Jun Li</a>.
                {/* Hi! I am Yinuo, a senior student at
                <a href='https://umich.edu/' target='_blanket'> University of Michigan, Ann Arbor,</a>&nbsp;
                majoring in Computer Science, where I am advised by <a href='https://from.so/Steve_Oney/' target='_blanket'>Prof. Steve Oney</a>. */}
              </p>
              {/* <br /> */}
              {/* <p>
                I am an <b>HCI researcher. </b>
                , and my research interest lies in <b>Human-AI Interaction</b>.
                I am particularly fascinated by how the processing and presentation of information, as well as interaction with it,
                can meaningfully facilitate human <b>learning</b>, <b>reasoning</b>, and <b>decision-making</b>.
                By designing systems that are transparent, adaptable, and aligned with human cognition, my goal is to
                enhance human <span style={{ fontWeight: '600' }}>intelligence</span> across diverse backgrounds.
              </p> */}

              <br />
              I am an HCI researcher. I had the great privilege of being mentored by <a href='https://from.so/Steve_Oney/' target='_blank'>Prof. Steve Oney</a>, <a href='https://aprilwang.me/' target='_blank'>Prof. April Yi Wang</a>, <a href='https://zhengzhang.me/' target='_blank'>Dr. Zheng Zhang</a>, and <a href='https://gezhangrp.com/' target='_blank'>Ashley Ge Zhang</a> during my undergraduate studies at the <a href='https://umich.edu/' target='_blank'>University of Michigan, Ann Arbor</a>.
              I’m deeply grateful for their guidance in introducing me to the world of HCI.
              <br />



              <div className="social-links_page">
                {/* <a href={cv} className="custom-social-link" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFile} />
                </a> */}
                <a href="https://github.com/inonnno" className="custom-social-link" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faGithub} />
                </a>
                <a href={`mailto:${'yinooyang@nd.edu'}`} className="custom-social-link" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faEnvelope} />
                </a>
                <a href="https://scholar.google.com/citations?hl=en&user=ZFZZTWEAAAAJ&view_op=list_works" className="custom-social-link" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faGoogleScholar} />
                </a>
                <a href="https://x.com/yino_yang" className="custom-social-link" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
                {/* <button id="more_about_me" onClick={toggleText}>More about me</button>
                <span id="more_about_me_content" style={{ display: 'none' }}>
                  &nbsp;
                  Outside of work,
                  I like sharing thoughts and
                  ideas with my friends,
                  who are my main source of mental support.
                  In the remaining time, I enjoy trying to
                  replicate my hometown dishes (I'm from a coastal
                  city, by the way) and writing Chinese calligraphy.
                  It is always a pleasure to meet new people! :)
                </span> */}
              </div>
            </p>
          </div>
          {/* <svg className="separator-svg_home" id="__1Dm1det__dd6d3b5d-736e-4112-a978-d559f0ef793b" data-name="70f8052d-3d8c-41fb-92d4-1085a59c667f" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.39 3.6">
        <title>seperator</title>
        <path
          d="M.35,1.9a3.73,3.73,0,0,0,2.7,1.2c3.5,0,2.3-2.6,5.8-2.6,2.9,0,3.1,2.6,5.8,2.6,3,0,2.6-2.6,5.7-2.6,2.8,0,3.3,2.6,5.8,2.6,3,0,2.8-2.6,5.8-2.6a4.37,4.37,0,0,1,3.1,1.4"
        ></path>
       </svg> */}
          <div style={{
            background: '#c6c6c62c',
            margin: '20px',
            border: '1px solid #eaeaea',
            borderRadius: '8px',
          }}>
            <div
              style={{
                padding: '15px',
                marginLeft: '10px',
                marginBottom: '10px',
              }}
            >
              <div className='projects_header' style={{
                marginBottom: '20px',
              }}>News </div>
              <div style={{
                paddingLeft: '10px',
              }}>
                <div className='news_content'>
                  <span className="left_news" style={{ fontWeight: 'bolder' }}>Oct 2025:</span>&nbsp;
                  <span className="right_news">
                    SPARK won the Honorable Mention Award at <a href='https://conf.researchr.org/home/vlhcc-2025' target=' _blank'>VL/HCC 2025</a>!!
                  </span>
                </div>
                <div className='news_content'>
                  <span className="left_news" style={{ fontWeight: '600' }}>July 2025:</span>&nbsp;
                  <span className="right_news">
                    My undergraduate thesis paper SPARK is accpeted by <a href='https://conf.researchr.org/home/vlhcc-2025' target=' _blank'>VL/HCC 2025</a>! Excited to present soon in Raleigh, NC!
                  </span>
                </div>
                <div className='news_content'>
                  <span className="left_news" style={{ fontWeight: '600' }}>July 2025:</span>&nbsp;
                  <span className="right_news">
                    Our paper "<a href={glitter_paper} target='_blank'>Glitter: An AI-assisted Platform for Material-Grounded Asynchronous Discussion in Flipped Learning</a>" is accpeted by <a href='https://uist.acm.org/2025/' target=' _blank'>UIST 2025</a>! See you soon in Busan, Korea!
                  </span>
                </div>
                <div className='news_content'>
                  <span className="left_news" style={{ fontWeight: '600' }}>April 2025:</span>&nbsp;
                  <span className="right_news">
                    I will join the <a href='https://www.nd.edu/' target=' _blank'>
                      University of Notre Dame
                    </a> as a PhD student in Fall 2025! So excited to start this new journey!
                  </span>
                </div>
                <div className='news_content'>
                  <span className="left_news" style={{ fontWeight: '600' }}>May 2024:</span>&nbsp;
                  <span className="right_news">
                    Our demonstration "<a href={VizCode} target=' _blank'>
                      VizCode: A Practical Real-time Tool for In-Class Computer Programming Tutoring
                    </a>" is accepted to <a href='https://learningatscale.acm.org/las2024/' target=' _blank'>L@S 2024</a>!
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* <svg className="separator-svg_home" id="__1Dm1det__dd6d3b5d-736e-4112-a978-d559f0ef793b" data-name="70f8052d-3d8c-41fb-92d4-1085a59c667f" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.39 3.6">
        <title>seperator</title>
        <path
          d="M.35,1.9a3.73,3.73,0,0,0,2.7,1.2c3.5,0,2.3-2.6,5.8-2.6,2.9,0,3.1,2.6,5.8,2.6,3,0,2.6-2.6,5.7-2.6,2.8,0,3.3,2.6,5.8,2.6,3,0,2.8-2.6,5.8-2.6a4.37,4.37,0,0,1,3.1,1.4"
        ></path>
        </svg> */}
          <div style={{
            marginTop: '30px',
            border: '1px solid #e5e5e5',
            borderWidth: '1px 0 0 0',
          }}>
            <div className='projects_header' > Publications 📚</div>
          </div>
          <p style={{ fontStyle: 'italic', }}>&nbsp;&nbsp; * indicates equal contribution</p>
          <Publications />
          {/* <div id="researchExperience">
            <div className='projects_header' > Research Experience 📎</div>
          </div>
          <Research_Projects /> */}
          <div style={{
            marginTop: '30px',
            border: '1px solid #e5e5e5',
            borderWidth: '1px 0 0 0',
          }}>
            <div className='projects_header' > Posters and Workshops 📎</div>
          </div>
          <Posters />
        </div >
      }
      {
        showPortfolioPage &&
        <div className='PortfolioPage' style={{
          border: '1px solid #e5e5e5',
          borderWidth: '1px 0 1px 0'
        }}>
          <div className='projects_header'> Portfolio 💡</div>
          <Other_Projects />
        </div>
      }
    </div >

  )
}

export default HomePage